import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-label" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "d-flex justify-content-end",
    "data-kt-customer-table-toolbar": "base"
  })
], -1)
const _hoisted_6 = { class: "card-body pt-0" }
const _hoisted_7 = { class: "d-flex justify-contents-start align-items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "me-3" }, "Date Range: ", -1)
const _hoisted_9 = { class: "d-flex justify-content-start align-items-center" }
const _hoisted_10 = { class: "symbol symbol-50px" }
const _hoisted_11 = { style: {"padding-left":"1em"} }
const _hoisted_12 = {
  key: 0,
  class: "d-flex flex-center flex-wrap"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary custom-slim-btn" }, "Report", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString($setup.breadcrumbs[1][$setup.breadcrumbs[1].length - 1]), 1)
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_el_date_picker, {
          modelValue: $setup.date,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.date) = $event)),
          type: "daterange",
          "start-placeholder": "DD/MM/YY",
          "end-placeholder": "DD/MM/YY"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_Datatable, {
        ref: "tableRef",
        "table-header": $setup.tableHeader,
        "table-data": _ctx.tableData,
        loading: _ctx.loading,
        total: _ctx.total
      }, _createSlots({
        "cell-no": _withCtx(({ index }) => [
          _createTextVNode(_toDisplayString(index + 1 + _ctx.rowsPerPage * (_ctx.currentPage - 1)), 1)
        ]),
        "cell-sumCommissionStore": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.sumCommissionStore ? $setup.numberFormat(row.sumCommissionStore) : '-'), 1)
        ]),
        "cell-sumFullPrice": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(row.sumFullPrice ? $setup.numberFormat(row.sumFullPrice) : '-'), 1)
        ]),
        "cell-storeDetail": _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", {
                class: "custom-image-box",
                style: _normalizeStyle(`background-image: url('${
                  row.store?.image ||
                  'media/images/steam-question-mark-icon-29.jpg'
                }')`)
              }, null, 4)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", null, _toDisplayString(row.store?.name?.th), 1)
            ])
          ])
        ]),
        "cell-moreDetail": _withCtx(({ row }) => [
          (!!row._id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_router_link, {
                  to: `/store-report/${row._id}${$setup.storeReportQuery}`
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, [
        _renderList($setup.tableHeader.filter(
            (data) =>
              ![
                'moreDetail',
                'no',
                'storeDetail',
                'sumCommissionStore',
                'sumFullPrice',
              ].includes(data.key)
          ), (item, i) => {
          return {
            name: `cell-${item.key}`,
            fn: _withCtx(({ row }) => [
              _createElementVNode("div", null, _toDisplayString(row[`${item.key}`]), 1)
            ])
          }
        })
      ]), 1032, ["table-header", "table-data", "loading", "total"])
    ])
  ]))
}